import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ConsentNotice({ accent, brandName, onApprove, contentColor, surfaceColor, t }) {
    const text = contentColor || "#e2e8f0";
    const surface = surfaceColor || "rgba(255,255,255,0.04)";
    const linkStyle = {
        color: accent,
        fontWeight: 700,
        textDecoration: "underline",
        textUnderlineOffset: "2px",
    };
    return (_jsxs("div", { style: {
            border: `1px solid ${accent}`,
            borderRadius: 14,
            padding: 12,
            background: surface,
            color: text,
            display: "grid",
            gap: 8,
        }, children: [_jsx("div", { style: { fontWeight: 700 }, children: t("consent.title") }), _jsx("p", { style: { fontSize: 13, opacity: 0.85, lineHeight: 1.4 }, children: t("consent.body", { brandName }) }), _jsxs("p", { style: { fontSize: 12, opacity: 0.92, lineHeight: 1.4, margin: 0 }, children: [_jsx("a", { href: "https://www.noahub.ai/bg/terms", target: "_blank", rel: "noreferrer", style: linkStyle, children: "Terms" }), " ", "\u00B7", " ", _jsx("a", { href: "https://www.noahub.ai/bg/privacy", target: "_blank", rel: "noreferrer", style: linkStyle, children: "Privacy Policy" })] }), _jsx("button", { onClick: onApprove, style: {
                    padding: "10px 12px",
                    borderRadius: 12,
                    border: "none",
                    background: accent,
                    color: "#0b1020",
                    fontWeight: 800,
                    cursor: "pointer",
                }, children: t("consent.cta") })] }));
}
